import {IAncestryUploadDetails} from 'Admin/AdminDashboard/models/Ancestry/IAncestryUploadDetails';
import {convertUTCToClientDate} from 'Common/helpers/DateHelper';

export function convertUploadedDetailsToClient(data: IAncestryUploadDetails): IAncestryUploadDetails {
  return {
    uploadDate: convertUTCToClientDate(data.uploadDate) || '',
  };
}
